const MODULE_NAME = "oncall/";

// Code & account identification
export const LOGIN = `@@${MODULE_NAME}LOGIN`;
export const LOGGED_IN = `@@${MODULE_NAME}LOGGED_IN`;
export const LOGOUT = `@@${MODULE_NAME}LOGOUT`;
export const IMPERSONATE = `@@${MODULE_NAME}IMPERSONATE`;
export const STOP_IMPERSONATING = `@@${MODULE_NAME}STOP_IMPERSONATING`;

// Creators
export const login = (username, password) => ({
  type: LOGIN,
  payload: {
    username,
    password,
  },
});

export const loggedIn = user => ({
  type: LOGGED_IN,
  payload: {
    user,
  },
});

export const logout = () => ({
  type: LOGOUT,
  payload: {},
});

export const impersonate = partnerId => ({
  type: IMPERSONATE,
  payload: {
    partnerId,
  },
});

export const stopImpersonating = () => ({
  type: STOP_IMPERSONATING,
  payload: {},
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/actions/auth.js